<script>
import StatusAwareAtom from "../StatusAwareComponent.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
  name: "ClockActionButton",
  components: {BasicButton},
  extends: StatusAwareAtom,
  computed: {
    icon() {
      return this.status === this.statuses.working ? "fi-sr-stop" : "fi-sr-play";
    },
    bg() {
      return this.status === this.statuses.working ? "bg-red" : "bg-green";
    },
    actionStatus() {
      return this.status === this.statuses.working ? "shift_end" : "shift_start";
    }
  }
}
</script>

<template>
  <div>
    <basic-button @click="$emit('statusChange', actionStatus)"
                  class="btn-circle btn-lg text-white button animated--grow-in" :class="bg" :icon="icon"/>

  </div>
</template>
